import React from 'react';
import {PractitionerCareTeamList} from "./PractitionerCareTeamList";
import {careTeamListReducer, initState} from "./practitionerCareTeamListReducer";
import {CreateNewCareTeamModal} from "./CreateNewCareTeamModal";
import {useSubmitNewPractitionerCareTeam$} from "./hook/useSubmitNewPractitionerCareTeam$";
import {showToast} from "common";
import {ErrorDialog} from "common/component/ErrorDialog";

type ClientProfileDocumentFileListPageParams = {
    clientGuid: string
}

export function ClientProfilePractitionerCareTeamListPage({clientGuid}: ClientProfileDocumentFileListPageParams) {
    const [{
        pagination,
        sortBy,
        showNewModal,
        refetchListFunc,
    }, dispatch] = React.useReducer(careTeamListReducer, initState())

    const {execute: submitOperation, isRunning$: isSubmitting$, errorMessage$} = useSubmitNewPractitionerCareTeam$(
        clientGuid,
        () => {
            showToast.success('Successfully add new Care Team Member');
            if (refetchListFunc) {
                refetchListFunc();
            }
        }
    )

    return (
        <div className="h-full relative">
            <PractitionerCareTeamList
                clientGuid={clientGuid}
                sortBy={sortBy}
                pagination={pagination}
                dispatch={dispatch}
            />
            <CreateNewCareTeamModal showModal={showNewModal}
                                    dispatch={dispatch}
                                    clientGuid={clientGuid}
                                    submitOperation={submitOperation}
                                    isSubmitting$={isSubmitting$}/>

            <ErrorDialog message$={errorMessage$} acceptButtonStyle={'atlantis'}/>
        </div>
    );
}
